import { provideUnsignedUploadDocumentStore } from 'src/app/recruiting/candidates/new-profile/candidate-uploaded-profile-document/store/unsigned-upload-document-store.providers';
import * as RootStoreProviders from './index';
import { EnvironmentProviders } from '@angular/core';

export const provideRootStore = (): EnvironmentProviders[] => [
    ...RootStoreProviders.provideAccountManagersDashboardStore(),
    ...RootStoreProviders.provideAccountManagersStore(),
    ...RootStoreProviders.provideAccountManagersSubmittalsStore(),
    ...RootStoreProviders.provideCandidateProfileComponentStore(),
    ...RootStoreProviders.provideComplianceStore(),
    ...RootStoreProviders.provideCredentialingStore(),
    ...RootStoreProviders.provideDashboardStore(),
    ...RootStoreProviders.provideDelegationsStore(),
    ...RootStoreProviders.provideDocAdminStore(),
    ...RootStoreProviders.provideEsignStore(),
    ...RootStoreProviders.provideFlyoutStore(),
    ...RootStoreProviders.provideHubConnectionStore(),
    ...RootStoreProviders.provideInAppNotificationsStore(),
    ...RootStoreProviders.provideInAppNotificationPreferencesStore(),
    ...RootStoreProviders.provideInvoiceStore(),
    ...RootStoreProviders.provideLeadQueueStore(),
    ...RootStoreProviders.provideLocumsStore(),
    ...RootStoreProviders.provideMarginCalculatorStore(),
    ...RootStoreProviders.provideNotesStore(),
    ...RootStoreProviders.providePerdiemStore(),
    ...RootStoreProviders.provideRecruitingJobsStore(),
    ...RootStoreProviders.provideRecruitingStore(),
    ...RootStoreProviders.provideReportingStore(),
    ...RootStoreProviders.provideReverseInvoiceStore(),
    ...RootStoreProviders.provideTicketStore(),
    ...RootStoreProviders.provideTicketEmailSettingsStore(),
    ...RootStoreProviders.provideTimecardStore(),
    ...RootStoreProviders.provideTravelXNewStore(),
    ...RootStoreProviders.provideWorkforceSolutionsStore(),
    ...provideUnsignedUploadDocumentStore()
];
